import React, { useEffect } from 'react';
import { AddForm } from '../../components/Webinars';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as R from 'ramda';
import applySelectors from '../../utils/applySelectors';
import questionsSelectors from '../../store/questions/selectors';
import questionsActions from '../../store/questions/actions';
import actions from '../../store/webinars/actions';
import { Spinner } from 'react-bootstrap';
import AddQuestionModalContainer from '../AddQuestionModalContainer';
import useModal from '../../hooks/useModal';

const AddWebinarContainer = ({
  questionsList,
  questions,
  getQuestions,
  addWebinar,
  uploadEmailImage,
  history,
  setSequencePage,
}) => {
  useEffect(() => {
    getQuestions();
  }, [getQuestions]);

  const [isQuestionModal, openQuestionModal, hideQuestionModal] = useModal();

  if (!questions) {
    return <Spinner />;
  }

  const onSubmitHandler = async (...args) => {
    try {
      await addWebinar(...args);
      setSequencePage(0);
      history.push('/webinars');
    } catch {
    }
  };

  return (
    <>
      <AddQuestionModalContainer show={isQuestionModal} onHide={hideQuestionModal} />
      <AddForm
        onSubmit={onSubmitHandler}
        questionsList={questionsList}
        questions={questions}
        openQuestion={openQuestionModal}
        uploadEmailImage={uploadEmailImage}
      />
    </>
  );
};

const mapStateToProps = applySelectors({
  questionsList: questionsSelectors.selectQuestions,
  questions: questionsSelectors.selectList,
});

export default R.pipe(
  connect(
    mapStateToProps,
    {
      ...actions,
      getQuestions: questionsActions.getQuestions,
    }
  ),
  withRouter,
)(AddWebinarContainer);
